import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ArticleComponent } from './pages/blog/article/article.component';
import { BlogComponent } from './pages/blog/blog.component';
import { CareerComponent } from './pages/career/career.component';
import { ConsultationComponent } from './pages/consultation/consultation.component';
import { ContactComponent } from './pages/contact/contact.component';
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/office/about/about.component';
import { StaffComponent } from './pages/office/staff/staff.component';
import { VisionComponent } from './pages/office/vision/vision.component';
import { Page404Component } from './pages/page404/page404.component';
import { ProjectsComponent } from './pages/projects/projects.component';
import { ArbitrationComponent } from './pages/service/arbitration/arbitration.component';
import { FacilityManagementComponent } from './pages/service/facility-management/facility-management.component';
import { ConstructionManagementComponent } from './pages/service/other-services/construction-management/construction-management.component';
import { DesigningComponent } from './pages/service/other-services/designing/designing.component';
import { EnvironmentalSustainabilityComponent } from './pages/service/other-services/environmental-sustainability/environmental-sustainability.component';
import { GreenBuildingsComponent } from './pages/service/other-services/green-buildings/green-buildings.component';
import { InfrastructureComponent } from './pages/service/other-services/infrastructure/infrastructure.component';
import { PlanningComponent } from './pages/service/other-services/planning/planning.component';
import { RoadsComponent } from './pages/service/other-services/roads/roads.component';
import { SupervisionComponent } from './pages/service/other-services/supervision/supervision.component';
import { VisionRealizationComponent } from './pages/service/other-services/vision-realization/vision-realization.component';
import { ProjectManagementComponent } from './pages/service/project-management/project-management.component';
import { TeamMemberComponent } from './pages/team/team-member/team-member.component';
import { TeamMember2Component } from './pages/team/team-member2/team-member2.component';
import { TeamComponent } from './pages/team/team.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    data: {
      title: 'Home',
      breadcrumb: ' Home'
    }
  },
  {
    path: 'blog',
    component: BlogComponent,
    data: {
      title: 'Blog',
      breadcrumb: 'Blog'
    }
  },
  {
    path: 'career',
    component: CareerComponent,
    data: {
      title: 'Career',
      breadcrumb: 'Career'
    }
  },
  {
    path: 'consultation',
    component: ConsultationComponent,
    data: {
      title: 'Consultation',
      breadcrumb: 'Consultation'
    }
  },
  {
    path: 'contact',
    component: ContactComponent,
    data: {
      title: 'Contact',
      breadcrumb: 'Contact'
    }
  },
  {
    path: 'projects',
    component: ProjectsComponent,
    data: {
      title: 'Projects',
      breadcrumb: 'Projects'
    }
  },
  {
    path: 'team',
    component: TeamComponent,
    data: {
      title: 'Team',
      breadcrumb: 'Team'
    }
  },
  {
    path: 'about',
    component: AboutComponent,
    data: {
      title: 'About',
      breadcrumb: 'About'
    }
  },
  {
    path: 'staff',
    component: StaffComponent,
    data: {
      title: 'Staff',
      breadcrumb: 'Staff'
    }
  },
  {
    path: 'vision',
    component: VisionComponent,
    data: {
      title: 'Vision',
      breadcrumb: 'Vision'
    }
  },
  {
    path: 'arbitration',
    component: ArbitrationComponent,
    data: {
      title: 'Arbitration',
      breadcrumb: 'Arbitration'
    }
  },
  {
    path: 'facility-management',
    component: FacilityManagementComponent,
    data: {
      title: 'FacilityManagement',
      breadcrumb: 'FacilityManagement'
    }
  },
  {
    path: 'project-management',
    component: ProjectManagementComponent,
    data: {
      title: 'ProjectManagement',
      breadcrumb: 'ProjectManagement'
    }
  },
  {
    path: 'construction-management',
    component: ConstructionManagementComponent,
    data: {
      title: 'ConstructionManagement',
      breadcrumb: 'ConstructionManagement' 
    }
  },
  {
    path: 'designing',
    component: DesigningComponent,
    data: {
      title: 'Designing',
      breadcrumb: 'Designing'
    }
  },
  {
    path: 'environmental-sustainability',
    component: EnvironmentalSustainabilityComponent,
    data: {
      title: 'EnvironmentalSustainability',
      breadcrumb: 'EnvironmentalSustainability'
    }
  },
  {
    path: 'green-buildings',
    component: GreenBuildingsComponent,
    data: {
      title: 'GreenBuildings',
      breadcrumb: 'GreenBuildings'
    }
  },
  {
    path: 'infrastructure',
    component: InfrastructureComponent,
    data: {
      title: 'Infrastructure',
      breadcrumb: 'Infrastructure'
    }
  },
  {
    path: 'planning',
    component: PlanningComponent,
    data: {
      title: 'Planning',
      breadcrumb: 'Planning'
    }
  },
  {
    path: 'roads',
    component: RoadsComponent,
    data: {
      title: 'Roads',
      breadcrumb: 'Roads'
    }
  },
  {
    path: 'supervision',
    component: SupervisionComponent,
    data: {
      title: 'Supervision',
      breadcrumb: 'Supervision'
    }
  },
  {
    path: 'vision-realization',
    component: VisionRealizationComponent,
    data: {
      title: 'VisionRealization',
      breadcrumb: 'VisionRealization'
    }
  },
  {
    path: 'article',
    component: ArticleComponent,
    data: {
      title: 'Article',
      breadcrumb: 'Article'
    }
  },
  {
    path: 'team-member',
    component: TeamMemberComponent,
    data: {
      title: 'TeamMember',
      breadcrumb: 'TeamMember'
    }
  },
  {
    path: 'team-member2',
    component: TeamMember2Component,
    data: {
      title: 'TeamMember2',
      breadcrumb: 'TeamMember2'
    }
  },
  {path:'', redirectTo:'/home', pathMatch:'full'},
  {path: "**", component: Page404Component}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
